import styled from 'styled-components';
import fsBg from 'src/assets/images/howtoplay/fsBg.png';

export const StyledFindSneakerMobile = styled.div`
  padding: 64px 0 100px 0;
  background-image: url(${fsBg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .container {
    width: 100%;
    .col-text {
      text-align: center;
      .main-title {
        font-family: 'Protector';
        font-style: normal;
        font-weight: 400;
        font-size: 40px;
        line-height: 46px;
        letter-spacing: 0.0125em;
        color: #ffffff;
        text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.5);
      }
      .title {
        font-family: 'Protector';
        font-style: normal;
        font-weight: 400;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        letter-spacing: 0.0125em;
        color: #ffffff;
        text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.5);
      }
    }
  }
`;
